import { TemplateResult, render as renderByLit, nothing } from 'lit-html';

/** コンポーネント */
export type FunctionalComponent<T> = (model: T) => TemplateResult;

/** 描画用関数 */
export const render = (templateResult: TemplateResult, container: HTMLElement | null) => {
  container && renderByLit(templateResult, container);
};

export const each = <T>(
  items: T[],
  iterator: (value: T, index: number, array: T[], options: {[key: string]: string}) => TemplateResult | '',
  options: {[key: string]: string} = {}
) => {
  const templateResult: TemplateResult[] = [];
  const length = items.length;
  for (let i = 0; i < length; i++) {
    const template = iterator(items[i], i, items, options);
    if (template) {
      templateResult.push(template);
    }
  }
  return templateResult;
};
export const If = (condition: boolean, templateResult: TemplateResult) =>
  (condition) ? templateResult : nothing;
